export default __webpack_public_path__ + "static/media/bookmark library empty.85074698.svg";